import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  label: {
    fontSize: '12px',
    fontWeight: 'bold',
    margin: '10px 0px',
    minWidth: '150px',
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    flex: '1',
  },
}));

export default function PrintableApplicationCheckbox(props) {
  const { classes } = useStyles();
  const { checked = false } = props;

  return (
    <div className={classes.root}>
      <div className={classes.label}>{props.label}</div>
      <Checkbox color="primary" checked={checked} />
    </div>
  );
}

PrintableApplicationCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
};
